var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorize"},[(!_vm.isWX)?_c('p',[_vm._v("请在微信浏览器打开")]):_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }